import { AggregationGroup } from 'src/app/services/jsonrpc/stats-server.service';
import { AnalyticsMetric } from 'src/app/services/stats.service';

import { Dashboard } from './dashboard.component';

const dashboard: Dashboard = {
  labels: ['type', 'unit', 'branch'],
  widgets: [
    {
      size: 3,
      component: 'users'
    },
    {
      size: 3,
      component: 'usersPeak'
    },
    {
      size: 3,
      component: 'usersPeakDate'
    },
    {
      size: 3,
      component: 'totalActiveTime'
    },

    {
      size: 12,
      component: 'multiTable',
      settings: {
        title: 'Overview',
        grouping: null,
        rows: [
          { title: 'Registered Users', metric: AnalyticsMetric.users },
          { title: 'Active Users', metric: AnalyticsMetric.active_users },
          { title: 'Games Played', metric: AnalyticsMetric.games_played },
          { title: 'Total Active Time', metric: AnalyticsMetric.time },
          { title: '... of it Quiz', metric: AnalyticsMetric.time, filter: { [AggregationGroup.feature]: 'quiz' } },
          { title: '... of it Wiki', metric: AnalyticsMetric.time, filter: { [AggregationGroup.feature]: 'wiki' } },
          { title: '... of it Flashcard', metric: AnalyticsMetric.time, filter: { [AggregationGroup.feature]: 'flashcard' } }
        ],
        totalColumn: true
      }
    },

    {
      component: 'barChart',
      settings: {
        title: 'Active Hours',
        subtitle: 'Total time in hours spent per branch in the app over the day',
        metric: AnalyticsMetric.time,
        datasets: 'label_branch',
        grouping: [AggregationGroup.hour],
        labelNames: '{value}:00',
        customize: false
      }
    },

    {
      component: 'barChart',
      settings: {
        title: 'Monthly Playtime',
        subtitle: 'Time per branch and month in hours spent in the app',
        metric: AnalyticsMetric.time,
        datasets: 'label_branch',
        grouping: [AggregationGroup.year, AggregationGroup.month],
        timespan: { years: 1 },
        customize: false
      }
    },

    {
      component: 'barChart',
      settings: {
        title: 'Active Hours',
        subtitle: 'Total time in hours spent per organization unit in the app over the day',
        metric: AnalyticsMetric.time,
        datasets: 'label_unit',
        grouping: [AggregationGroup.hour],
        labelNames: '{value}:00',
        customize: false
      }
    },

    {
      component: 'barChart',
      settings: {
        title: 'Monthly Playtime',
        subtitle: 'Time per organization unit and month in hours spent in the app',
        metric: AnalyticsMetric.time,
        datasets: 'label_unit',
        grouping: [AggregationGroup.year, AggregationGroup.month],
        timespan: { years: 1 },
        customize: false
      }
    },

    // {
    //   component: 'barChart',
    //   settings: {
    //     title: 'Playtime in Modules',
    //     subtitle: 'Time per branch in modules',
    //     metric: AnalyticsMetric.time,
    //     datasets: 'label_branch',
    //     grouping: AggregationGroup.path_segment_1,
    //     exclude: {
    //       [AggregationGroup.path_segment_1]: ['article', 'glossary', 'invite', 'Sidemenu']
    //     },
    //     customize: false,
    //     totalRow: false,
    //     totalColumn: false,
    //     relative: false
    //   }
    // },

    // {
    //   component: 'barChartFiltered',
    //   settings: {
    //     title: 'Playtime in Modules',
    //     subtitle: 'Time per branch in modules',
    //     metric: AnalyticsMetric.time,
    //     selector: AggregationGroup.path_segment_1,
    //     grouping: AggregationGroup.path_segment_2,
    //     datasets: 'label_branch',
    //     exclude: {
    //       [AggregationGroup.path_segment_1]: 'Sidemenu',
    //       ['label_branch']: ''
    //     },
    //     customize: false,
    //     totalRow: false,
    //     totalColumn: false,
    //     relative: false
    //   }
    // },

    {
      component: 'lineGraph',
      settings: {
        title: 'Active Hours',
        subtitle: 'Total time in hours spent in the app over the day',
        metric: AnalyticsMetric.time,
        datasets: AggregationGroup.feature,
        grouping: AggregationGroup.hour,
        labelNames: '{value}:00'
      }
    },

    {
      component: 'lineGraph',
      settings: {
        title: 'Daily Playtime',
        subtitle: 'Total recent time in hours spent in the app',
        metric: AnalyticsMetric.time,
        datasets: AggregationGroup.feature,
        grouping: AggregationGroup.date,
        timespan: { days: 21 }
      }
    },

    {
      component: 'lineGraph',
      settings: {
        title: 'Weekly Playtime',
        subtitle: 'Total recent time in hours spent in the app',
        metric: AnalyticsMetric.time,
        datasets: AggregationGroup.feature,
        grouping: [AggregationGroup.year, AggregationGroup.week],
        timespan: { weeks: 12 }
      }
    },

    {
      component: 'lineGraph',
      settings: {
        title: 'Monthly Playtime',
        subtitle: 'Total recent time in hours spent in the app',
        metric: AnalyticsMetric.time,
        datasets: AggregationGroup.feature,
        grouping: [AggregationGroup.year, AggregationGroup.month],
        timespan: { months: 12 }
      }
    },

    {
      component: 'barChart',
      settings: {
        title: 'Video Plays',
        filter: {
          [AggregationGroup.feature]: 'video'
        },
        metric: AnalyticsMetric.media_plays,
        grouping: AggregationGroup.path,
        customize: false
      }
    },

    {
      component: 'barChart',
      settings: {
        title: 'Podcast Plays',
        filter: {
          [AggregationGroup.feature]: 'podcast'
        },
        metric: AnalyticsMetric.media_plays,
        grouping: AggregationGroup.path,
        customize: false
      }
    },

    {
      size: 12,
      component: 'transitionGraph'
    }
  ]
};

export default dashboard;
